import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import MomentUtils from '@date-io/moment';
import { Paper, Grid, Typography } from '@material-ui/core';
import { alignCenterXY, InputContainer, listRemoveBtnStyle } from './styles';
import { Button } from '../../generators/FormGenerator/styles';

import { DateListInput } from '../../store/inputs/DateListInput';
import { getISODateTimeString } from '../../utils/dateUtils';

const CDateListInput = observer(({ item }: { item: DateListInput }) => {
  const {
    label,
    value,
    selectorValue,
    onChange,
    onChangeValue,
    disabled,
    error,
    tag,
    isKey,
    isEdit,
  } = item;
  const [dates, setDates] = useState<Date[]>([]);

  useEffect(() => {
    setDates(value || []);
  }, [value]);

  const addDate = () => {
    if (
      selectorValue &&
      !dates.find((dt: Date) => dt.toString() === selectorValue.toString())
    ) {
      const newDates: Date[] = [...dates, selectorValue as Date];
      onChangeValue(newDates);
      onChange(null, true);
    }
  };

  const removeDate = (date: Date) => {
    const removeIndex = dates.findIndex((dt: Date) => dt === date);

    if (removeIndex >= 0) {
      const newDates = [...dates];
      newDates.splice(removeIndex, 1);
      onChangeValue(newDates);
    }
  };

  return (
    <Grid container wrap="wrap" spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <Paper style={{ padding: '5px', margin: '10px 0' }}>
          <InputContainer>
            <Typography style={{ color: '#777' }}>{label}</Typography>
            <div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Grid
                  container
                  wrap="wrap"
                  spacing={3}
                  style={{ ...alignCenterXY, justifyContent: 'flex-start' }}
                >
                  <Grid item xs={6} style={{ paddingRight: '0' }}>
                    <KeyboardDatePicker
                      disableToolbar
                      disabled={disabled || (isKey && isEdit)}
                      error={!!error}
                      helperText={error}
                      format="DD/MM/YYYY"
                      margin="normal"
                      id={tag}
                      label={label}
                      value={selectorValue}
                      onChange={(d) =>
                        onChange(d ? new Date(d.toDate()) : null, true)
                      }
                      onFocus={() => {}}
                      onBlur={() => {}}
                    />
                  </Grid>

                  <Grid item xs={4} style={{ paddingLeft: '0' }}>
                    <KeyboardTimePicker
                      margin="normal"
                      disabled={disabled || (isKey && isEdit)}
                      placeholder="08:00 AM"
                      label="Select time"
                      format="hh:mm A"
                      value={selectorValue}
                      onChange={(d) =>
                        onChange(d ? new Date(d.toDate()) : null, false)
                      }
                      KeyboardButtonProps={{ 'aria-label': 'Select time' }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={2}
                    style={{ ...alignCenterXY, paddingBottom: '0' }}
                  >
                    {isKey ? <i className="bx bx-key" style={{ fontSize: '18px' }}></i> : null}
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </div>

            {dates && dates.length
              ? dates.map((dt) => {
                  return (
                    <Button
                      key={dt.toString()}
                      style={listRemoveBtnStyle}
                      onClick={() => removeDate(dt)}
                      disabled={disabled || (isKey && isEdit)}
                    >
                      {!(disabled || (isKey && isEdit)) ? (
                        <i className="bx bx-x-circle" style={{ color: '#aa0000', fontSize: '24px' }}></i>
                      ) : null}
                      {typeof dt === 'string'
                        ? getISODateTimeString(dt)
                        : getISODateTimeString(dt.toString())}
                    </Button>
                  );
                })
              : null}
          </InputContainer>
          <Button 
            style={{ margin: '0 0 5px 5px' }} 
            onClick={() => addDate()}
            disabled={disabled || (isKey && isEdit)}
          >
            Add
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
});

export default CDateListInput;
